module.exports = __webpack_public_path__ + "6819b6e0466dc92a44bf6c1eeee9d129.jpg";